
export const PROGRAMA: string = process.env.REACT_APP_PROGRAMA || 'Farmapontos';